import mutations from './mutations';
import actions from './actions';

const defaultState = () => {
  return {};
};

const AiJobs = {
  namespaced: true,
  state: defaultState,
  getters: {},
  mutations,
  actions,
};

export { AiJobs, defaultState };
